import React, { useEffect, useRef, useState } from "react";
import { Button, AutoComplete, message, Select } from "antd";
import { Col, Container, Row } from "react-bootstrap";
import { Alert } from "antd";
import { getAddress, getCoordinates } from "../../api/Login";
import { Icon } from "@iconify/react/dist/iconify.js";
import Loader from "../../customJS/Loader";
import { useNavigate } from "react-router-dom";
import { getDoctorSpecialities } from "../../api/Doctor";
import { middleware } from "../../RTK/middleware";
import { useDispatch, useSelector } from "react-redux";
import { dispatchConst } from "../../RTK/type";
import useAuthService from "../../session/useAuthService";

const Home = () => {
  const [alert, setAlert] = useState(false);
  const [address, setAddress] = useState(useAuthService.getAddress());
  const [latLng, setLatLng] = useState(useAuthService.getLatLng());
  const [loader, setLoader] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [options, setOptions] = useState([]); // For AutoComplete suggestions
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isFirstRender = useRef(true);

  const [speciality, setSpeciality] = useState(useAuthService.getSpeciality());
  const doctorSpecialities = useSelector(({ main }) => main.specialities || []);

  useEffect(() => {
    // console.log("sessionData", useAuthService.getAddress(), useAuthService.getLatLng(), useAuthService.getSpeciality());
    console.log("speciality:::", speciality, doctorSpecialities);

    // getSpeciality();
    if (doctorSpecialities?.length === 0) {
      getSpeciality();
    }
    // specialityId: speciality,
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const timer = setTimeout(() => {
      if (address) {
        setLatLng(null);
        fetchSuggestions(address);
      } else {
        setOptions([]);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [address]);

  let autocompleteService = null; // Google Places AutocompleteService

  const fetchSuggestions = (query) => {
    if (!autocompleteService) {
      autocompleteService = new window.google.maps.places.AutocompleteService();
    }
    autocompleteService.getPlacePredictions(
      { input: query },
      (predictions, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          setOptions(
            predictions.map((prediction) => ({
              value: prediction.description,
              place_id: prediction.place_id,
            }))
          );
        }
      }
    );
  };

  const handlePlaceSelect = (value, option) => {
    const placeId = option.place_id;
    const placesService = new window.google.maps.places.PlacesService(
      document.createElement("div")
    );

    placesService.getDetails(
      { placeId, fields: ["geometry.location", "formatted_address"] },
      (place, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          const location = place.geometry.location;
          setAddress(place.formatted_address);
          setLatLng(`${location.lat()},${location.lng()}`);
        } else {
          messageApi.error("Unable to fetch place details. Please try again.");
        }
      }
    );
  };

  const getSpeciality = () => {
    setLoader(true);
    getDoctorSpecialities({})
      .then((response) => {
        if (response.data.status === 1) {
          dispatch(
            middleware({
              data: response.data.data,
              dispatchType: dispatchConst.specialities,
            })
          );
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };

  // const handleSearch = (value) => {
  //   setAddress(value);
  //   if (value) {
  //     fetchSuggestions(value);
  //   } else {
  //     setOptions([]);
  //   }
  // };

  const handleSearch = (value) => {
    setAddress(value); // updates the value and triggers debounce in useEffect
  };

  const handleGetLocation = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const obj = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };
        setLoader(true);
        getAddress(obj).then((response) => {
          setLoader(false);
          if (response.data.status === 1) {
            isFirstRender.current= true;
            setLatLng(`${obj.latitude},${obj.longitude}`);
            setAddress(response.data.data);
          }
        });
      },
      (error) => {
        console.error("Error occurred:", error.message);
      }
    );
  };
  function requestLocation() {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        console.log("Location obtained:", position.coords);
      },
      (error) => {
        console.error("Error requesting location:", error.message);
      }
    );
  }

  const checkLocation = () => {
    navigator.permissions
      .query({ name: "geolocation" })
      .then((permissionStatus) => {
        console.log("Permission status:", permissionStatus.state);

        if (permissionStatus.state === "granted") {
          // Permission already granted, get location
          handleGetLocation();
          // getLocation();
        } else if (permissionStatus.state === "prompt") {
          // Permission denied, inform user to enable location manually
          requestLocation();
        } else if (permissionStatus.state === "denied") {
          setAlert(true);
        }

        // Listen for changes in permission state
        permissionStatus.onchange = () => {
          console.log("Permission status changed to:", permissionStatus.state);

          if (permissionStatus.state === "granted") {
            setAlert(false);
          } else {
            setAlert(true);
          }
        };
      });
  };

  const handleSearchDoctors = () => {
    useAuthService.storeAddress(address);
    useAuthService.storeLatLng(latLng);
    useAuthService.storeSpeciality(speciality);
    if (address && latLng) {
      console.log("latLng::", latLng, address);
      navigate(
        `/yourDoctors?latLong=${btoa(latLng)}&address=${btoa(
          address
        )}&speciality=${btoa(speciality)}`
      );
    } else if (address && !latLng) {
      getCoordinatesFromAddress({ address: address });
    } else {
      messageApi.error("Please enter an address");
    }
  };

  const getCoordinatesFromAddress = (obj) => {
    console.log("lat:", obj);
    setLoader(true);
    getCoordinates(obj).then(
      (response) => {
        // var result = response.data;
        setLoader(false);
        if (response.data.status === 1) {
          console.log("response.data:", response.data.data);
          let lat = response.data.data[0] + "," + response.data.data[1];
          // setLatLng(response.data.data[0] + "," + response.data.data[1]);
          // navigate(`/yourDoctors?latLong=${lat}`);

          navigate(
            `/yourDoctors?latLong=${btoa(lat)}&address=${btoa(
              address
            )}&speciality=${btoa(speciality)}`
          );
          // setAddress(response.data.data);
          // setGoogleAddress(response.data.data);
        }else{
          messageApi.error("Sorry, we were unable to determine your location from the address provided. Please enter a different location.");
        }
      },
      (error) => {
        console.error("Error occurred:", error.message);
      }
    );
  };
  const onChange = (value) => {
    console.log(`selected ${value}`);
    // console.log(typeof value);
    setSpeciality(value);
    // setCurrentPage(0);
  };

  return (
    // <LoadScript googleMapsApiKey={REACT_APP_GOOGLE_MAPS_API_KEY} libraries={libraries}>
    <Container className="doctor-home-bg">
      {contextHolder}
      {loader && <Loader />}
      {alert && (
        <Alert
          message="Please enable location permissions in your browser settings."
          type="error"
        />
      )}
      <Row className="h-100 d-flex justify-content-center align-items-end">
        <Col lg={8} sm={12} className="mb-5">
          <h2 className="uniteColor text-center font-family-Mar mb-4">
            Find the Medical Office
          </h2>
          <Row className="d-flex justify-content-center">
            <Col className="background-white px-4 me-md-4 mb-sm-5 mb-md-0">
              <div className="d-flex align-items-center">
                <div className="w-100">
                  <small className="d-block uniteColor m-0">Specialtiy</small>
                  <Select 
                    placeholder="Choose A Speciality"
                    size="small"
                    showSearch
                    onChange={onChange}
                    value={speciality || undefined}
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    className="yourDoctor-filter w-100"
                    options={[
                      { label: "All", value: 0 },
                      // ...doctorSpecialities,
                      ...(doctorSpecialities || []),
                    ]}
                    dropdownStyle={{ minWidth: "300px" }}
                    style={{ minWidth: 150 }} // Optional: Set minimum width
                  />
                </div>
              </div>
            </Col>
            <Col className="background-white px-4">
              <div className="d-flex align-items-center justify-content-between">
                <div style={{ width: "50%" }}>
                  <small className="d-block uniteColor m-0">Location</small>
                  <AutoComplete
                    style={{ width: "100%" }}
                    options={options}
                    value={address}
                    onSearch={handleSearch}
                    onSelect={handlePlaceSelect}
                    placeholder="Address, City & State Or Zip"
                    className="home-autocomplete "
                  />
                </div>
                <Button className="use-location" onClick={checkLocation}>
                  Use Current Location
                </Button>
              </div>
            </Col>
          </Row>
          <div align="center" className="mt-4 fs-6">
            <Button
              onClick={handleSearchDoctors}
              className="uniteButton-lg quick-search fs-15 border-0 font-weight-bold"
            >
              Quick Search{" "}
              <Icon
                icon="material-symbols:search-rounded"
                width="30"
                height="30"
              />
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
    // </LoadScript>
  );
};

export default Home;
